import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-200">
      <Header />
      <div className="max-w-4xl mx-auto px-6 py-12 pt-24">
        <h1 className="text-4xl font-bold mb-6 text-center text-indigo-600 dark:text-indigo-400">
          How to Play
        </h1>
        <p className="text-lg mb-6 text-gray-700 dark:text-gray-300">
          MathMaster is an interactive platform designed to help students practice math concepts like multiplication, squares, cubes, fractions, and advanced calculations. Our mission is to make math learning fun, accessible, and engaging for everyone.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-indigo-600 dark:text-indigo-400">
          How to Play
        </h2>
        <ul className="list-disc list-inside text-lg mb-6 text-gray-700 dark:text-gray-300">
          <li>Select a game mode from the available options (e.g., Squares, Cubes, Fractions).</li>
          <li>Use the arrow keys (<kbd>←</kbd>, <kbd>→</kbd>) to navigate through questions.</li>
          <li>Press the <kbd>Space</kbd> bar to reveal the answer to the current question.</li>
          <li>Click the "Skip" button or press <kbd>S</kbd> to move to the next question without answering.</li>
          <li>Adjust the range of numbers for the game using the range selector to customize difficulty.</li>
        </ul>
        <h2 className="text-2xl font-semibold mb-4 text-indigo-600 dark:text-indigo-400">
          About the Developer
        </h2>
        <p className="text-lg mb-6 text-gray-700 dark:text-gray-300">
          This project is developed and maintained by a passionate developer who loves creating tools that make learning easier. If you enjoy using MathMaster, consider supporting the developer to keep this project alive and free for everyone.
        </p>
        <div className="flex justify-center">
          <button
            onClick={() => window.open('https://superprofile.bio/vp/64188fab190024001f59f638', '_blank')}
            className="px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg hover:from-purple-700 hover:to-pink-700 transition-all flex items-center gap-2"
          >
            <span>Donate to Support</span>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
